import { Grid } from '@mui/material';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';

export function FormGrid({ children }: PpWC): React.ReactElement {
  return (
    <Grid container spacing={2.5}>
      {children}
    </Grid>
  );
}
